import React, { useState } from 'react';
import Link from 'next/link';
import { useSelector } from 'react-redux';
import Register from '../../auth/components/Register';
import PageHeader from '../../../components/shared-components/PageHeader';
import { publicSubscriptionRoutes } from '@/utils/subscriptionRoutes';

const Welcome = () => {
    const { profile } = useSelector((state) => state.auth);

    const [registerOpen, setRegisterOpen] = useState(false);

    return (
        <>
            <PageHeader
                title={<>Burocrazia <span className="text-[#8fc045]">Zero.</span></>}
                subtitle={<>Il primo CAF 100% Online. Semplice,<br />veloce e senza code.</>}
            >
                <div className="flex w-full flex-col items-center justify-center gap-[24px]">
                    <div className="flex w-full max-w-[396px] items-stretch justify-center gap-[8px] md:w-auto md:max-w-none md:gap-[16px]">
                        <Link
                            href={publicSubscriptionRoutes.promo}
                            className="flex min-h-[48px] min-w-0 flex-1 items-center justify-center rounded-[8px] border border-solid border-transparent bg-[#8fc045] px-[10px] py-[12px] text-center no-underline transition-colors hover:bg-[#7ab035] md:flex-none md:px-[32px] md:py-[14px]"
                        >
                            <span className="font-['Inter'] text-[16px] font-bold leading-[20px] text-white [text-wrap:balance] md:whitespace-nowrap">
                                Abbonati e Risparmia
                            </span>
                        </Link>
                        <Link
                            href='/servizi'
                            className="group flex min-h-[48px] min-w-0 flex-1 items-center justify-center rounded-[8px] border border-solid border-[#262f39] bg-white px-[10px] py-[12px] text-center no-underline transition-colors hover:border-[#8fc045] md:flex-none md:px-[32px] md:py-[14px]"
                        >
                            <span className="font-['Inter'] text-[16px] font-bold leading-[20px] text-[#262f39] [text-wrap:balance] transition-colors group-hover:text-[#8fc045] md:whitespace-nowrap">
                                Cerca un servizio
                            </span>
                        </Link>
                    </div>
                </div>
            </PageHeader>

            <Register open={registerOpen} setOpen={setRegisterOpen} />
        </>
    );
};

export default Welcome;
